<div class="visma-integration">
  <p class="visma-integration--title">
    {{ 'Settings.Integration.VismaExpense.Title' | translate | uppercase }}
  </p>
  <p class="visma-integration--description">
    {{ 'Settings.Integration.VismaExpense.Description' | translate }}
  </p>

  <div class="visma-integration__content">
    <p>{{ 'Settings.Integration.VismaExpense.FormDescription' | translate }}</p>
    <div class="visma-integration__form">
      <div class="visma-integration__form--label">
        {{ 'Settings.Integration.VismaExpense.ToggleName' | translate }}
      </div>
      <dv-dynamic-form
        [elements]="[element] | translateElements"
        [formGroup]="formGroup">
      </dv-dynamic-form>
      <div>
        {{
          formGroup.value.IsVismaExpenseConnected
            ? ('General.On' | translate)
            : ('General.Off' | translate)
        }}
      </div>
    </div>
  </div>
</div>
<dv-save-panel
  [editPermissions]="{
    formGroup,
    permissions: [userPermissions.IntegrationSettingsEdit],
  }"
  [disableSave]="!formGroup.dirty || !formGroup.valid"
  labelCancel=""
  labelSave="{{ 'General.Save' | translate }}"
  (save)="onSave()">
</dv-save-panel>
